module.exports = __webpack_public_path__ + "static/media/livre-recettes.95d9abc3.png";